"use strict";
/**
 * Slippage Utilities
 * Resolves the effective slippage value based on independent mode and side
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEffectiveSlippage = getEffectiveSlippage;
const DEFAULT_SLIPPAGE_PERCENT = 3;
/**
 * Get the effective slippage value for a given side.
 * When independent slippage is enabled, returns the side-specific value.
 * Otherwise, returns the shared slippage value.
 */
function getEffectiveSlippage(settings, side) {
    if (settings.independentSlippage) {
        return side === "yes"
            ? settings.slippageTolerancePercentA ?? DEFAULT_SLIPPAGE_PERCENT
            : settings.slippageTolerancePercentB ?? DEFAULT_SLIPPAGE_PERCENT;
    }
    return settings.slippageTolerancePercent ?? DEFAULT_SLIPPAGE_PERCENT;
}
